const contactUs = (params) => Peace.http.post('/open-mall-portal/portal/front/messageBoard/add', params)

export default {
    contactUs
}
